import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, takeUntil } from 'rxjs/operators';
import { isEmptyEncounterId, currentEncounterId } from '@mona/pdms/data-access-combined';
import { isSameEncounterFilter } from '@mona/shared/utils';
import { makeDefaultAsyncActionEffect } from '@mona/store';
import { PreMedicationsState } from '../../entities';
import { PreMedicationsApi } from '../../infrastructure';
import { PreMedicationsAction } from '../actions';

/**
 * Pre medications effects
 */
@Injectable()
export class PreMedicationsEffects {
    /* Effect Declarations */

    /**
     * Load pre medications effect
     */

    loadPreMedications$ = createEffect(() =>
        this.actions$.pipe(
            ofType(PreMedicationsAction.loadPreMedicationsAction.action),
            switchMap(action =>
                makeDefaultAsyncActionEffect(
                    this.preMedicationsApi
                        .getPreMedications(action.encounterId)
                        .pipe(
                            isSameEncounterFilter(currentEncounterId(this.store), action.encounterId),
                            takeUntil(isEmptyEncounterId(this.store)),
                        ),
                    PreMedicationsAction.loadPreMedicationsAction,
                ),
            ),
        ),
    );

    /**
     * Constructor
     *
     * @param actions$ Actions
     * @param preMedicationsApi PreMedicationsApi
     * @param store Store<PreMedicationsState>
     */
    constructor(
        private actions$: Actions,
        private preMedicationsApi: PreMedicationsApi,
        private store: Store<PreMedicationsState>,
    ) {}
}
